import React from "react";
import RouteObject from "react-router-dom";
import BuyerLayout from "../../layout/BuyerLayout/BuyerLayout";
import AllActiveBuyer from "../../pages/LADBuyer/ActiveBuyerList/AllActiveBuyer";
import BuyerSettings from "../../pages/LADBuyer/BuyerSettings/BuyerSettings";
import FormSettings from "../../pages/LADBuyer/BuyerSettings/SubComponents/FormSettings/FormSettings";
import CommunicationSettings from "../../pages/LADBuyer/BuyerSettings/SubComponents/CommunicationSettings/CommunicationSettings";
import ViewSettings from "../../pages/LADBuyer/BuyerSettings/SubComponents/ViewSettings/ViewSettings";
import SubscriptionSettings from "../../pages/LADBuyer/BuyerSettings/SubComponents/SubscriptionSettings/SubscriptionSettings";
import ViewBuyerLayout from "../../layout/BuyerLayout/SubLayouts/ViewBuyerLayout/ViewBuyerLayout";
import ViewBuyerDetails from "../../pages/LADBuyer/ViewBuyer/Buyer Details/ViewBuyerDetails";
import PurchasedLeads from "../../pages/LADBuyer/ViewBuyer/PurchasedLeads/PurchasedLeads";
import SubscriptionPlan from "../../pages/LADBuyer/ViewBuyer/SubscriptionPlan/SubscriptionPlan";
import PurchaseHistory from "../../pages/LADBuyer/ViewBuyer/PurchaseHistory/PurchaseHistory";
import ReviewAndRatings from "../../pages/LADBuyer/ViewBuyer/ReviewAndRatings/ReviewAndRatings";
import RFQsQuotes from "../../pages/LADBuyer/ViewBuyer/RFQsQuotes/RFQsQuotes";
import CommunicationHistory from "../../pages/LADBuyer/ViewBuyer/CommunicationHistory/CommunicationHistory";
import TrashBuyers from "../../pages/LADBuyer/Trash/TrashBuyers";
import { UpdateBuyerLayOut } from "../../layout/BuyerLayout/SubLayouts/ViewBuyerLayout/UpdateBuyerLayOut";
import { UpdateBuyer } from "../../pages/LADBuyer/updateBuyer/UpdateBuyer";
import AddBuyers from "../../pages/LADBuyer/AddBuyer/AddBuyers";

       const BuyerRoutes: RouteObject[] = [
  {                
    path: "buyer",
    element: <BuyerLayout />,
    children: [
      {
        index: true,
        element: <AllActiveBuyer />,
      },
      {
        path: "all-active-buyer",
        element: <AllActiveBuyer />,
      },
      {
        path: "add-buyer",
        element: <AddBuyers />,
      },
      {
        path: "Buyer-trash",
        element: <TrashBuyers />,
      },
      {
        path: "buyersettings",
        element: <BuyerSettings />,
        children: [
          {
            index: true,
            element: <FormSettings />,
          },
          {
            path: "formsettings",
            element: <FormSettings />,
          },
          {
            path: "communicationsetting",
            element: <CommunicationSettings />,
          },
          {
            path: "viewsettings",
            element: <ViewSettings />,
          },
          {
            path: "subscriptionsettings",
            element: <SubscriptionSettings />,
          },
        ],
      },

      {
        path: "all-active-buyer",
        element: <AllActiveBuyer />,
        children: [
          {
            path: "view-buyer",
            element: <ViewBuyerLayout />,
          },
        ],
      },
    ],
  },
  {
    path: "update-buyer",
    element: <UpdateBuyerLayOut />,
    children: [
      {
        index: true,
        element: <UpdateBuyer />,
      },
      {
        path: "update-buyer",
        element: <UpdateBuyer />,
      },
    ],
  },
  {
    path: "view-buyer/",
    element: <ViewBuyerLayout />,
    children: [
      {
        index: true,
        element: <ViewBuyerDetails />,
      },
      {
        path: "buyer-details/",
        element: <ViewBuyerDetails />,
      },
      {
        path: "purschase",
        element: <PurchasedLeads />,
      },
      {
        path: "subscriptionplan",
        element: <SubscriptionPlan />,
      },
      {
        path: "purschasehistories",
        element: <PurchaseHistory />,
      },
      {
        path: "reviewratings",
        element: <ReviewAndRatings />,
      },
      {
        path: "rfqs",
        element: <RFQsQuotes />,
      },
      {
        path: "commmunication",
        element: <CommunicationHistory />,
      },
    ],
  },
];

export default BuyerRoutes;
